import { ErrorText, styled, TextInput } from '@arpeggi/ui'
import { FC } from 'react'
import { Controller, UseFormReturn } from 'react-hook-form'
import { CreateRedirectFormFields } from '../types'

const urlRegex =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()!@:%_\+.~#?&\/\/=]*)/

const StyledErrorText = styled(ErrorText, { marginTop: '8px' })

interface Props {
  form: UseFormReturn<CreateRedirectFormFields, any>
  name: keyof CreateRedirectFormFields
}

export const UrlTextInput: FC<Props> = ({ form, name }) => {
  return (
    <Controller
      name={name}
      control={form.control}
      rules={{
        required: {
          value: true,
          message: 'Required'
        },
        pattern: {
          value: urlRegex,
          message: 'Url is invalid'
        }
      }}
      render={({ field, fieldState: { error } }) => (
        <>
          <TextInput
            id={name}
            placeholder={`${window.location.origin}.com/home/songs`}
            {...field}
          />
          <StyledErrorText>{error?.message}</StyledErrorText>
        </>
      )}
    />
  )
}
